export default __webpack_public_path__ + "static/media/ER21.e534de70.png";